import { Component } from 'react';
import jxWindowManager from './JxWindowManager.jsx';
import ComponentNotifier from '../../services/wss/ComponentNotifier';

/**
 * JxWindowManagerPainter — isolated repaint target for JxWindowManager.
 * Registers itself as the painter so only this component re-renders on window open/close/tab-switch.
 * Must be rendered inside UserSettingsProvider (and other app-level providers) — see App.jsx.
 */
export default class JxWindowManagerPainter extends Component {
    componentDidMount() {
        jxWindowManager.registerPainter(() => this.forceUpdate());
        this._unsubTab = ComponentNotifier.subscribe('TabEngine', () => this.forceUpdate());
    }

    componentWillUnmount() {
        if (this._unsubTab) this._unsubTab();
        jxWindowManager.registerPainter(null);
    }

    render() {
        return <>{jxWindowManager.paint()}</>;
    }
}
